import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import componentWithConditionDeprecated from '@jira/platform__component-with-condition/src/index.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { globalMailSettingsRoute } from '@jira/router-routes__global-mail-settings-routes/src/globalMailSettingsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import RedirectToLegacyRouting from './common/ui/redirect/legacy-routing/index.tsx';
import GlobalMailSettings, { LazyGlobalMailSettings } from './ui/index.tsx';

export const globalMailSettingsRouteEntry: Route = createEntry(globalMailSettingsRoute, () => ({
	group: 'global-settings',
	ufoName: 'admin.global-mail-settings',

	// eslint-disable-next-line no-restricted-syntax
	component: componentWithConditionDeprecated(
		() => true,
		GlobalMailSettings,
		RedirectToLegacyRouting,
	),

	layout: globalSettingsLayout,

	navigation: {
		sidebarId: SidebarIdGlobalSystemSettings,
		menuId: MenuIdSettings,
	},

	resources: [...getNavigationResources(), navigationSidebarGlobalResource],
	forPaint: [LazyAtlassianNavigation, LazyGlobalMailSettings],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
